import { ClaimMessages, TranslationClaimMessages } from "../interfaces";

export const messages : TranslationClaimMessages = {
  [ClaimMessages.access]: "Acceder",
  [ClaimMessages.activateFutureStatus]: "Status futuro activo",
  [ClaimMessages.activateStatus]: "Status activo",
  [ClaimMessages.alter]: "Cambiar",
  [ClaimMessages.changeStatus]: "Cambiar status",
  [ClaimMessages.changeSupply]: "Cambiar insumo",
  [ClaimMessages.commercialDefault]: "Estándar comercial",
  [ClaimMessages.costChangeReminder]: "Recordatorio de cambio de costo",
  [ClaimMessages.createCopy]: "Crear copia",
  [ClaimMessages.delete]: "Eliminar",
  [ClaimMessages.export]: "Exportar",
  [ClaimMessages.inactivate]: "Inactivar",
  [ClaimMessages.inactivateStatus]: "Status inactivo",
  [ClaimMessages.include]: "Incluir",
  [ClaimMessages.print]: "Imprimir",
  [ClaimMessages.technicalDataChangeReminder]: "Recordatorio de cambio de dato técnico",
  [ClaimMessages.abramsCurveChangeReminder]: "Recordatorio de cambio de curva de Abrams",
  [ClaimMessages.includeLogo]: "Incluir logo",
  [ClaimMessages.deleteLogo]: "Eliminar logo",
  [ClaimMessages.download]: "Descargar",
  [ClaimMessages.alterExternalId]: "Cambiar id externo",
  [ClaimMessages.changeAllocations]: "Cambiar asignaciones",
  [ClaimMessages.dispatch]: "Despachar",
  [ClaimMessages.reintegrate]: "Reintegrar",
  [ClaimMessages.cancel]: "Cancelar",
  [ClaimMessages.requestAdjustment]: "Solicitar ajuste",
  [ClaimMessages.approveAdjustment]: "Aprobar ajuste",
  [ClaimMessages.changeLink]: "Cambiar Enlace",
  [ClaimMessages.ignoreLink]: "Ignorar Enlace",
  [ClaimMessages.closeInventory]: "Cerrar Inventario",
  [ClaimMessages.closeProduction]: "Cerrar Producción",
  [ClaimMessages.reopenProduction]: "Reabrir Producción",
  [ClaimMessages.alterDelivery]: "Alterar Entrega",
  [ClaimMessages.alterPumping]: "Alterar Bombeo",
  [ClaimMessages.alterScheduling]: "Alterar Programación",
  [ClaimMessages.approveDisapprovePendingRequests]: "Aprobar/Desaprobar Solicitudes Pendientes",
  [ClaimMessages.changeDeliveryRoute]: "Cambiar Ruta de Entrega",
  [ClaimMessages.reopenInventory]: "Reabrir Inventario",
  [ClaimMessages.dispatchPumpingTicket]: "Despachar Boleto de Bombeo",
  [ClaimMessages.waterCut]: "Corte de Agua",
  [ClaimMessages.sendToAutomation]: "Enviar a Automatización",
  [ClaimMessages.creditLimitWebserviceResendForAnalysis]: "Reenviar análisis de límite de crédito",
  [ClaimMessages.alertsPageAccess]: "Página de Alertas - Acceder",
  [ClaimMessages.clientPrepaidAlter]: "Cliente prepago - Cambiar",
  [ClaimMessages.constructionNotFoundAlter]: "Obra no encontrada - Cambiar",
  [ClaimMessages.constructionExpiredAlter]: "Obra vencida - Cambiar",
  [ClaimMessages.schedulingWithoutExternalIdAlter]: "Programación sin ID externo - Cambiar",
  [ClaimMessages.supplyNotAuthorizedBySecurityVisitAlter]: "Insumo no autorizado por visita de seguridad - Cambiar",
  [ClaimMessages.productWithoutQuotationAlter]: "Producto sin cotización - Cambiar",
  [ClaimMessages.productOrRecipeInactiveAlter]: "Producto o receta inactiva - Cambiar",
  [ClaimMessages.clientDelinquentAlter]: "Cliente moroso - Cambiar",
  [ClaimMessages.clientExpiredCreditDateAlter]: "Fecha de crédito del cliente vencida - Cambiar",
  [ClaimMessages.clientWithoutCreditLimitAlter]: "Cliente sin límite de crédito - Cambiar",
  [ClaimMessages.waitingCreditLimitAnalysisAlter]: "Esperando análisis de límite de crédito - Cambiar",
  [ClaimMessages.plantUnavailableAlter]: "Planta no disponible - Cambiar",
  [ClaimMessages.closeScheduling]: "Cerrar Programación",
  [ClaimMessages.reopenScheduling]: "Reabrir Programación",
  [ClaimMessages.blockReasonCreditLimitValidation]: "Validación de límite de crédito",
  [ClaimMessages.blockReasonCreditLimitAnalysis]: "Esperando análisis de límite de crédito",
  [ClaimMessages.blockReasonProductGroupRequiresApproval]: "Grupo de producto requiere aprobación",
  [ClaimMessages.blockReasonNotSentForAutomation]: "No enviado para automatización",
  [ClaimMessages.blockReasonProductRequiresApproval]: "Producto requiere aprobación",
  [ClaimMessages.blockReasonProductTypeRequiresApproval]: "Tipo de producto requiere aprobación",
  [ClaimMessages.blockReasonSupplyDeviation]: "Desviación de suministro",
  [ClaimMessages.blockReasonSupplyGroupDeviation]: "Desviación de grupo de suministro",
  [ClaimMessages.blockReasonMissingAutomationResponse]: "Respuesta de automatización ausente",
  [ClaimMessages.blockReasonInsufficientStock]: "Stock insuficiente",
  [ClaimMessages.blockReasonGravelNoLoadReuseParamSet]: "Grava sin parámetro de reutilización de carga definido",
  [ClaimMessages.blockReasonProductGroupNoLoadReuseParamSet]: "Grupo de producto sin parámetro de reutilización de carga definido",
  [ClaimMessages.blockReasonProductNoLoadReuseParamSet]: "Producto sin parámetro de reutilización de carga definido",
  [ClaimMessages.blockReasonProductGroupReuseOutOfParams]: "Grupo de producto fuera de los parámetros de reutilización",
  [ClaimMessages.blockReasonProductReuseOutOfParams]: "Producto fuera de los parámetros de reutilización",
  [ClaimMessages.blockReasonGravelReuseOutOfParams]: "Grava fuera de los parámetros de reutilización",
  [ClaimMessages.blockReasonDivergentVolume]: "Volumen divergente",
  [ClaimMessages.blockReasonWaitingCreditLimitAnalysis]: "Esperando análisis de límite de crédito",
  [ClaimMessages.blockReasonExpiredCreditDate]: "Fecha de crédito expirada",
  [ClaimMessages.inconsistencyActualSlump]: "Slump actual",
  [ClaimMessages.inconsistencyConcreteMixerSchedules]: "Horarios de hormigoneras",
  [ClaimMessages.inconsistencyWaterAddedInConstruction]: "Agua agregada en la obra",
  [ClaimMessages.inconsistencyOdometer]: "Odómetro",
  [ClaimMessages.inconsistencyHourMeter]: "Horímetro",
  [ClaimMessages.inconsistencyPumpScheduleWithoutDeliveryTicketPump]: "Programación de bombas sin ticket de entrega",
  [ClaimMessages.inconsistencyPumpScheduleMissingM3ToIssueDelivery]: "Cantidad emitida difiere de la cantidad programada",
  [ClaimMessages.inconsistencyUndeliveredAndUncancelledSchedules]: "Programación no entregados y no cancelados",
  [ClaimMessages.inconsistencyUndeliveredAndUncancelledDeliveries]: "Entregas no realizadas y no canceladas",
  [ClaimMessages.inconsistencyUnlinkedWeighings]: "Pesajes no vinculados",
  [ClaimMessages.inconsistencySefazStatusFiscalDocumentNotSend]: "Documento fiscal no enviado",
  [ClaimMessages.inconsistencySefazStatusFiscalDocumentNoAnswer]: "Documento fiscal sin respuesta",
  [ClaimMessages.inconsistencySefazStatusFiscalDocumentWithRejection]: "Documento fiscal con rechazo",
  [ClaimMessages.inconsistencyAdditionalModifications]: "Modificaciones adicionales",
  [ClaimMessages.inconsistencyLoadTicketWithoutDeliveryTicket]: "Ticket de carga sin ticket de envío emitido",
  [ClaimMessages.viewReports]: "Ver Reportes",
  [ClaimMessages.registerExecution]: "Registrar Ejecución",
  [ClaimMessages.updateExecution]: "Actualizar Ejecución",
  [ClaimMessages.deleteExecution]: "Eliminar Ejecución",
  [ClaimMessages.completeTask]: "Completar Tarea",
  [ClaimMessages.addNotes]: "Agregar Notas",
  [ClaimMessages.viewPlantStatus]: "Ver Estado de la Planta",
  [ClaimMessages.viewProduction]: "Ver Producción",
  [ClaimMessages.viewAlarms]: "Ver Alarmas",
  [ClaimMessages.manualCommand]: "Comando Manual",
  [ClaimMessages.adjustOrders]: "Ajustar Pedidos",
  [ClaimMessages.acknowledgeAlarm]: "Reconocer Alarma",
  [ClaimMessages.authorizePrivileged]: "Autorizar Privilegiado",
  [ClaimMessages.manageLocalUsers]: "Gestionar Usuarios Locales",
  [ClaimMessages.viewAudit]: "Ver Auditoría",
  [ClaimMessages.plantDefinition]: "Definición de Planta",
  [ClaimMessages.inconsistencyLoadReuseWithoutDestination]: "Reutilizaciones sin destino informado",
  [ClaimMessages.manualEntry]: "Registro Manual",
  [ClaimMessages.alterApplicationOfOwnLabor]: "Editar aplicación de mano de obra propia en el bombeo",
  [ClaimMessages.adjustedStrength]: "Resultado ajustado de la rotura",
  [ClaimMessages.excludeRuptureFromStatistics]: "Excluir rotura de las estadísticas",
  [ClaimMessages.alterProductWeighted]: "Cambiar receta a pesar"
};
